import { render, staticRenderFns } from "./project-item.vue?vue&type=template&id=0fba6d6f"
import script from "./project-item.vue?vue&type=script&lang=js"
export * from "./project-item.vue?vue&type=script&lang=js"
import style0 from "./project-item.vue?vue&type=style&index=0&id=0fba6d6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports